import { useState, useEffect, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { API_URL, scroll, getValFromLS, setValToLS } from "../helpers";
import Alert from "../components/Alert";

function useQuery() {
	const { search } = useLocation();
	return useMemo(() => new URLSearchParams(search), [search]);
}

const RegReceipt = () => {
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const history = useHistory();
	const query = useQuery();

	useEffect(() => {
		const init = async () => {
			if (getValFromLS("auth") && getValFromLS("order")) {
				const auth = getValFromLS("auth");
				const order = getValFromLS("order");

				/* copy local back to session, remove local */
				setValToLS("auth", auth, true);
				setValToLS("order", order, true);
				setValToLS("auth", null);
				setValToLS("order", null);

				const url = new URL(`${API_URL}/registrationReceipt`);
				let data = new FormData();
				data.append("order", order);
				data.append("auth", auth);
				data.append("responseCode", query.get("x_response_code") || "");
				data.append("responseText", query.get("x_response_reason_text") || "");
				data.append("authCode", query.get("x_auth_code") || "");
				data.append("transactionId", query.get("x_trans_id") || "");
				data.append("amt", query.get("x_amount") || "");
				data.append("sequence", query.get("x_fp_sequence") || "");
				data.append("card", query.get("Card_Number") || "");
				data.append("avs", query.get("x_avs_code") || "");
				data.append("csv", query.get("x_cvv2_resp_code") || "");

				try {
					const response = await fetch(url, {
						method: "POST",
						body: data,
					});
					const json = await response.json();
					if (json && json.resp === 1) {
						let orderFromLS = JSON.parse(order);
						orderFromLS.payment = "credit";
						orderFromLS.billto = {
							prefix: json.prefix,
							fname: json.fname,
							lname: json.lname,
							title: json.title,
							organization: json.organization,
							address: json.address,
							address2: json.address2,
							city: json.city,
							st: json.st,
							zip: json.zip,
						};
						setValToLS("order", JSON.stringify(orderFromLS), true);
						setValToLS("receipt", JSON.stringify(json.receipt), true);

						history.push("/registration/submitted");
					} else {
						setAlert({
							type: "error",
							text: json.text,
						});
						scroll();
					}
				} catch (error) {
					setAlert({
						type: "error",
						text: "An error has occurred.",
					});
				}

				scroll();
			} else {
				history.push("/registration");
			}
		};

		init();

		// eslint-disable-next-line
	}, []);

	return <Alert data={alert} />;
};

export default RegReceipt;
